import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';
import { CountdownPage } from '../countdown/countdown';

import { LoginPage } from '../login/login';
import { StakingPage } from '../staking/staking';

/**
 * Generated class for the StakinglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-stakinglist',
  templateUrl: 'stakinglist.html',
})
export class StakinglistPage {

    loginId: string;
	email: string;
	jikgeup: string;
    api_key: string;
    version: string;

    list: any = [];
	count: string;	
	// completed_list: any = [];
	// pending_list: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;	
	unit: string;
    
    balance: any = [];
    value: string;

	texts: any = [];
    language : string;

    isButton : boolean = true;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
        private http: HttpService,
		public app: App
	) {
		// this.wallet_address = navParams.get("wallet_address");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "staking_list");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.jikgeup = localStorage.getItem("jikgeup");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).staking_list;
	}

    _staking() {
        this.navCtrl.push(StakingPage);
	}

	_init() {		
		this.list = [];
		// this.completed_list = [];
		// this.pending_list = [];
		
        let url = "staking/base/index/list";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.balance = res.balance;
                this.count = res.count;
				// this.office_address = res.address;
                // this.rate = res.rate;
                // this.value = res.value;

                if (res.list != undefined) {   
                    this.list = res.list;
                }
                // if (res.list != undefined) {   
                //     if(res.list.completed != undefined) {
                //         this.completed_list = res.list.completed;
                //     }
                //     if(res.list.pending != undefined) {
                //         this.pending_list = res.list.pending;
                //     }
                // }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

    _staking_event(idx) {
        this.navCtrl.push(CountdownPage, {idx: idx});
    }

	// _doInfinite(infiniteScroll) {
    //     setTimeout(() => {    
    //         for (var i = 0; i < 9; i++) {
    //             if(this.max_length <= this.count) break;
    //             this.params.push(this.items[this.count]);                
    //             this.count++;
    //         } 

    //         infiniteScroll.complete();
    //     }, 500);
	// }

	// _copy_office(office_address) {
	// 	this.clipboard.copy(office_address);
	// 	let alert = this.alertCtrl.create({
    //     title: "Copy",
    //     message: office_address, 
	// 	buttons: ['OK']
	// 	});
	// 	alert.present();
	// }
}



// WEBPACK FOOTER //
// ./src/pages/stakinglist/stakinglist.ts